export interface Faq {
  question: string;
  answer: string;
}

// Article #4 — Best Pool Deck Materials for South Florida.
// The visible FAQ section and the FAQPage schema both read from this single
// shared array, so the on-page content and the structured data always match
// exactly.

export const FAQS_BEST_POOL_DECK_MATERIALS: Faq[] = [
  {
    question: "What is the best pool deck material for South Florida?",
    answer:
      "There is no single best material for every South Florida pool deck. Concrete pavers, travertine, marble, and outdoor-rated porcelain each offer different combinations of appearance, maintenance, repairability, absorption, texture, and installation requirements. The right choice depends on the exact product, property conditions, sun exposure, design, budget, and homeowner priorities.",
  },
  {
    question: "What pool deck material stays coolest in the sun?",
    answer:
      "No material is always coolest under every condition. Surface temperature can be affected by color, density, finish, moisture, direct-sun exposure, time of day, and weather. Lighter-colored options are often considered for barefoot areas, but homeowners should compare actual samples and product-specific information rather than rely on a universal ranking.",
  },
  {
    question: "Is travertine a good pool deck material in South Florida?",
    answer:
      "Travertine can be a strong candidate for homeowners who want natural variation and a warm, resort-inspired appearance. The exact stone, color, finish, porosity, maintenance expectations, installation, and wet-area conditions should be evaluated before selection.",
  },
  {
    question: "Are concrete pavers good around a pool?",
    answer:
      "Concrete or brick-style pavers can work well around pools when the exact product and texture are suitable for the application and the deck is properly planned and installed. They offer broad design flexibility and may allow individual units to be addressed later, although replacement pieces may not blend perfectly with older material.",
  },
  {
    question: "Can porcelain pavers be used around a pool?",
    answer:
      "Yes, certain porcelain pavers are designed for exterior wet applications. Homeowners should confirm the exact product's intended-use classification, surface finish, thickness, installation requirements, drainage needs, and manufacturer guidance. Indoor porcelain tile should not automatically be used outdoors around a pool.",
  },
  {
    question: "Is marble too slippery for a pool deck?",
    answer:
      'The word "marble" alone does not determine wet-area suitability. Finish and product selection matter. A polished interior marble surface should not be assumed suitable for a pool deck. The exact exterior product, texture, application guidance, installation, drainage, and maintenance conditions must be reviewed.',
  },
  {
    question: "Do pool deck pavers need to be sealed?",
    answer:
      "It depends on the material, product, finish, installation, exposure, maintenance goals, and manufacturer guidance. Sealing may affect appearance, absorption, cleaning, and surface behavior. It should be treated as a product-specific decision rather than an automatic rule for every paver or natural stone.",
  },
  {
    question: "Should pool coping match the deck?",
    answer:
      "Pool coping does not have to be identical to the deck, but the two should be intentionally coordinated. Color, thickness, edge profile, texture, joint layout, elevation, and compatibility with the pool finish and tile should be reviewed together before materials are ordered.",
  },
];

export const TOC_BEST_POOL_DECK_MATERIALS = [
  {
    id: "the-short-answer",
    title: "The Short Answer: There Is No Single Best Pool Deck Material",
  },
  {
    id: "what-matters-most",
    title: "What Matters Most for a South Florida Pool Deck?",
  },
  {
    id: "comparison-at-a-glance",
    title: "Pool Deck Material Comparison at a Glance",
  },
  {
    id: "concrete-and-brick-pavers",
    title: "Concrete and Brick Pavers",
  },
  {
    id: "travertine-pavers",
    title: "Travertine Pavers",
  },
  {
    id: "marble-pavers",
    title: "Marble Pavers",
  },
  {
    id: "outdoor-porcelain-pavers",
    title: "Outdoor Porcelain Pavers",
  },
  {
    id: "other-pool-deck-options",
    title: "Other Pool Deck Options Worth Understanding",
  },
  {
    id: "which-material-fits-which-homeowner",
    title: "Which Material Fits Which Type of Homeowner?",
  },
  {
    id: "why-color-and-finish-matter",
    title: "Why Color and Finish Matter as Much as Material",
  },
  {
    id: "what-to-check-before-final-selection",
    title: "What to Check Before Making a Final Selection",
  },
  {
    id: "frequently-asked-questions",
    title: "Frequently Asked Questions",
  },
];
